import React, { useEffect, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import Button from '../Button/Button';
import Dropdown from '../Dropdown/Dropdown';
import styles from './ColorPicker.module.scss';
function ColorPicker({ name, value = '#aabbcc', onChange }) {
    const [color, setColor] = useState(value);
    const hasPendingUpdate = useRef(false);
    useEffect(() => {
        setColor(value);
    }, [value]);
    useEffect(() => {
        const handlePointerUp = () => {
            if (hasPendingUpdate.current) {
                onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name, value: color } });
                hasPendingUpdate.current = false;
            }
        };
        document.addEventListener('pointerup', handlePointerUp);
        return () => {
            document.removeEventListener('pointerup', handlePointerUp);
        };
    }, [color, name, onChange]);
    const handleChangeColor = (newColor) => {
        setColor(newColor);
        hasPendingUpdate.current = true;
    };
    return (React.createElement(Dropdown, { closeOnClick: false, trigger: React.createElement(Button, { theme: "ghost", shape: "squared" },
            React.createElement("span", { className: styles.color, style: {
                    background: value ||
                        'linear-gradient(to right, #eea2a2 0%, #bbc1bf 19%, #57c6e1 42%, #b49fda 79%, #7ac5d8 100%)',
                } })) },
        React.createElement("main", { className: styles.container },
            React.createElement(HexColorPicker, { color: color, onChange: handleChangeColor }))));
}
export default ColorPicker;
